module.exports = __webpack_public_path__ + "static/p-miftah-c2fdc5ce39f1885b2e955d6cc9daa6b3.jpg";